<template>
  <div class="event">
    <div class="gridElement h-100">
      <div class="id flex align-items-center header">
        {{ t("global.missingEvent") }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

const { t } = useTranslation();
</script>

<style lang="scss" src="@/components/event-action/shared.scss"></style>

<style lang="scss" scoped>
.event {
  border: 1px solid var(--p-gray-900);
  border-radius: 3px;

  .grow {
    display: flex;
    align-items: center;
  }
}
</style>
<style lang="scss">
.buttonGroup {
  .btn-sm {
    font-size: 0.875em !important;
  }
}
</style>
